import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "./../root/Login";
import {Button, Card, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiCheck, BiIdCard, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "./../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {GetUsuaris} from "../../dao/root/GetUsuaris";
import {defaultUser, User} from "../../model/root/User";
import UsuarisList from "../menudesign/components/UsuarisList";
import {defaultUsuariRolEscoles, UsuariRolEscoles} from "../../model/root/UsuariRolEscoles";
import UsuarisModal from "../menudesign/components/UsuarisModal";
import {defaultRol, Rol} from "../../model/root/Rol";
import RolsList from "../menudesign/components/RolsList";
import RolModal from "../menudesign/components/RolModal";
import {DeleteRol} from "../../dao/root/DeleteRol";
import {DeleteUsuari} from "../../dao/root/DeleteUsuari";
import {CiClock2} from "react-icons/ci";
import toast, {Toaster} from "react-hot-toast";
import {PostUsiarisIdValidacio} from "../../dao/root/PostUsiarisIdValidacio";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {GetHoraris} from "../../dao/root/GetHoraris";
import HorariModal from "../menudesign/components/HorariModal";
import {PutHorari} from "../../dao/root/PutHorari";

const Usuaris = () => {
    const titol: string = "Usuaris";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<User[]>([]);
    const [coleccioR, setDadesR] = useState<Rol[]>([]);
    const [horaris, setHoraris] = useState<any[]>([]);
    const [coleccioTot, setDadesTot] = useState<UsuariRolEscoles>(defaultUsuariRolEscoles);
    const [elementSelected, setElementSelected] = useState<User>(defaultUser);
    const [elementSelectedR, setElementSelectedR] = useState<Rol>(defaultRol);
    const [elementSelectedH, setElementSelectedH] = useState<any>({id:0});
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementH, setNouElementH] = useState(false);
    const [nouElementR, setNouElementR] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visibleRols, setVisibleRols] = useState(false);
    const [visibleHoraris, setVisibleHoraris] = useState(false);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        setLoading(true);
        const dades = await GetUsuaris(page);
        console.log(dades);
        setDades(dades.usuaris);
        setDadesR(dades.rols);
        setDadesTot(dades);
        setHoraris(await GetHoraris(page));
        setNameFilters(dades.usuaris);
        handleLoadingChange(false);
        setLoading(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function toggleTableRols() {
        setVisibleRols(!visibleRols);
    }

    async function deleteElement(id: number) {
        setLoading(true);
        await DeleteUsuari(id, page, userId);
        await checkDades();
    }

    async function deleteElementR(id: number) {
        setLoading(true);
        await DeleteRol(id, page, userId);
        await checkDades();
    }

    async function deleteElementH(ele: any) {
        setLoading(true);
        await PutHorari(page, {...ele, estat: -1}, userId);
        await checkDades();
    }

    function afegirElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function afegirElementR(element: Rol) {
        setNouElementR(!nouElement);
        setElementSelectedR(element);
    }

    function togleNouElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElementH(element: any) {
        setNouElementH(!nouElement);
        setElementSelectedH(element);
    }

    function togleNouElementR(element: Rol) {
        setNouElementR(!nouElement);
        setElementSelectedR(element);
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }

    function handleCloseModalR() {
        setNouElementR(false);
        checkDades();
    }
    function handleCloseModalH() {
        setNouElementH(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: User[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);
    }

    function showEstadistiques(ele: number) {
        navigate("/controlhorari/" + ele);
    }

    async function activarUsuari(id: number) {
        //toast.error("PENDENT DE PROGRAMAR");
        await PostUsiarisIdValidacio(id + "", page, toast);
        setLoading(true);
        await GetUsuaris(page);
        await checkDades();
    }

    const columns: ColumnsType<User> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Usuari',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'nombre',
            title: 'Nom',
            dataIndex: 'nombre',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            responsive: ['lg'],
            sorter: (a, b) => a.estat - b.estat,
            sortOrder: "descend",
            render: (estat, ele) => (
                <>
                    <Tag color={estat === 1 ? Colors.colors.color4 : Colors.colors.color1}>
                        {estat === 1 ? "Actiu" : "Pendent"}
                    </Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 120,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiPencil/></Button>
                    {" "}
                    <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => deleteElement(ele.id)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiTrash/></Button>
                    {" "}
                    {ele.estat === 1 ?
                        <Button title={"Horari i estadístiques"} style={{backgroundColor: Colors.colors.color4}}
                                onClick={() => showEstadistiques(ele.id)}
                                hidden={ele.nom.lastIndexOf("superusuari") !== -1}><CiClock2/></Button>
                        :

                        <Popconfirm
                            title="Activació d'usuari"
                            description="Vols activar aquest usuari? Cal primer assignar-li permisos"
                            onConfirm={() => activarUsuari(ele.id)}
                            icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                        >
                            <Button title={"Activar"} style={{backgroundColor: Colors.colors.color3}}
                                    hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiCheck/></Button>
                        </Popconfirm>
                    }
                    {" "}
                    <Button title={"Perfil"} style={{backgroundColor: Colors.colors.color2}}
                            onClick={() => navigate("/profile/" + ele.id)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiIdCard/></Button>
                </>
            ),
        },
    ];

    const columnsR: ColumnsType<Rol> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElementR(ele)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiPencil/></Button>
                    {" "}
                    <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => deleteElementR(ele.id)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiTrash/></Button>
                </>
            ),
        },
    ];

    const columnsH: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 30,
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 30,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElementH(ele)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiPencil/></Button>
                    {" "}
                    <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => deleteElementH(ele)}
                            hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiTrash/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<User> = {
        loading
    };

    const tablePropsR: TableProps<Rol> = {
        loading
    };

    const onChange: TableProps<User>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: User) => {
        return (
            <UsuarisList element={ele} elements={coleccioTot} hoaris={horaris} checkDades={checkDades} page={page}/>
        );
    };

    const onChangeR: TableProps<Rol>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const onChangeH: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRenderR2 = (ele: Rol) => {
        return (
            <RolsList element={ele} elements={coleccioTot} checkDades={checkDades} page={page}/>
        );
    };

    function afegirElementH(param: any) {
        setNouElementH(!nouElement);
        setElementSelectedH(param);
    }

    function showNouUsuari(): void {
        const { origin } = window.location; // Solo el dominio y protocolo
        const newUrl = `${origin}/treballadors`;
        window.open(newUrl, '_blank'); // Abre en nueva pestaña
    }

    if (isLoggedIn) {

        return (
            <div>
                <NavBar/>
                <Toaster/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Afegir"} style={{backgroundColor: Colors.colors.color2}} onClick={() => showNouUsuari()}><BiPlus/></Button>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElementR(defaultRol)}><BiPlus/></Button>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTableRols}>Rols</h4>
                        {visibleRols && (
                            <Table
                                {...tablePropsR}
                                onChange={onChangeR}
                                columns={columnsR}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRenderR2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccioR}
                            />
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElementH({id:0})}><BiPlus/></Button>
                            <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={() => setVisibleHoraris(!visibleHoraris)}>Horaris</h4>
                        {visibleHoraris && (
                            <Table
                                {...tablePropsR}
                                onChange={onChangeH}
                                columns={columnsH}
                                dataSource={horaris}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <UsuarisModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                      page={page} id_usu_log={userId}/>
                    )}
                    {nouElementR && (
                        <RolModal element={elementSelectedR} onClose={handleCloseModalR} visible={nouElementR}
                                  page={page} id_usu_log={userId}/>
                    )}
                    {nouElementH && (
                        <HorariModal element={elementSelectedH} onClose={handleCloseModalH} visible={nouElementH}
                                     page={page} id_usu_log={userId}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Usuaris;
